// Runtime config. Values come from public/config.js, which nginx serves and the
// deploy writes -- so an environment's targets can change without a rebuild.
// Falls back to build-time env so local dev works with just .env.development.
const runtime = (typeof window !== "undefined" && window.__RMW_CONFIG__) || {};

export const APP_ENV =
  runtime.APP_ENV || import.meta.env.VITE_APP_ENV || "local";

export const API_URL =
  runtime.API_URL || import.meta.env.VITE_API_URL || "http://localhost:5001";

export const FUNNEL_URL =
  runtime.FUNNEL_URL || import.meta.env.VITE_FUNNEL_URL || "http://localhost:3000";
